<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2019-11-04',
        items: [

          // [NOTE] KR
          // ================================================================================

          item({
            collection  : 'プリチケパック1',
            id          : 'AM-175',
            rare        : 'KR',
            name        : 'ピュアプリンセスロゼキラッとワンピ',
            imgUrl      : '/images/items/AM-175.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-176',
            rare        : 'KR',
            name        : 'ピュアプリンセスロゼキラッとシューズ',
            imgUrl      : '/images/items/AM-176.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-177',
            rare        : 'KR',
            name        : 'ピュアプリンセスロゼキラッとヘアアクセ',
            imgUrl      : '/images/items/AM-177.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            rare        : 'KR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'プリチケパック1',
            id          : 'AM-126',
            rare        : 'PR',
            name        : 'ラビットカメオピンクトップス',
            imgUrl      : '/images/items/AM-126.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-127',
            rare        : 'PR',
            name        : 'ラビットカメオピンクスカート',
            imgUrl      : '/images/items/AM-127.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-128',
            rare        : 'PR',
            name        : 'ラビットカメオピンクシューズ',
            imgUrl      : '/images/items/AM-128.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-129',
            rare        : 'PR',
            name        : 'ラビットカメオピンクヘアアクセ',
            imgUrl      : '/images/items/AM-129.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック1',
            id          : 'AM-130',
            rare        : 'PR',
            name        : 'スーパーサイリウムみかんアナザーワンピ',
            imgUrl      : '/images/items/AM-130.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-131',
            rare        : 'PR',
            name        : 'スーパーサイリウムみかんアナザーシューズ',
            imgUrl      : '/images/items/AM-131.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-132',
            rare        : 'PR',
            name        : 'スーパーサイリウムみかんアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-132.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            rare        : 'PR',
          }),


          item({
            collection  : 'プリチケパック1',
            id          : 'AM-133',
            rare        : 'PR',
            name        : 'スーパーサイリウムガァルルアナザーワンピ',
            imgUrl      : '/images/items/AM-133.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-134',
            rare        : 'PR',
            name        : 'スーパーサイリウムガァルルアナザーシューズ',
            imgUrl      : '/images/items/AM-134.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-135',
            rare        : 'PR',
            name        : 'スーパーサイリウムガァルルアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-135.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            rare        : 'PR',
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'プリチケパック1',
            id          : 'AM-136',
            rare        : 'SR',
            name        : 'フラワーパーティートップス',
            imgUrl      : '/images/items/AM-136.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-137',
            rare        : 'SR',
            name        : 'フラワーパーティースカート',
            imgUrl      : '/images/items/AM-137.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-138',
            rare        : 'SR',
            name        : 'フラワーパーティーシューズ',
            imgUrl      : '/images/items/AM-138.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-139',
            rare        : 'SR',
            name        : 'フラワーパーティーヘアアクセ',
            imgUrl      : '/images/items/AM-139.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック1',
            id          : 'AM-140',
            rare        : 'SR',
            name        : 'ホリックトリックブルーサイリウムワンピ',
            imgUrl      : '/images/items/AM-140.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-141',
            rare        : 'SR',
            name        : 'ホリックトリックブルーサイリウムシューズ',
            imgUrl      : '/images/items/AM-141.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-142',
            rare        : 'SR',
            name        : 'ホリックトリックブルーサイリウムヘアアクセ',
            imgUrl      : '/images/items/AM-142.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリチケパック1',
            id          : 'AM-143',
            rare        : 'SR',
            name        : 'ココフラワーブルーサイリウムワンピ',
            imgUrl      : '/images/items/AM-143.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-144',
            rare        : 'SR',
            name        : 'ココフラワーブルーサイリウムシューズ',
            imgUrl      : '/images/items/AM-144.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-145',
            rare        : 'SR',
            name        : 'ココフラワーブルーサイリウムヘアアクセ',
            imgUrl      : '/images/items/AM-145.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            rare        : 'SR',
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'プリチケパック1',
            id          : 'AM-146',
            rare        : 'R',
            name        : 'ワイズガールブラウントップス',
            imgUrl      : '/images/items/AM-146.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-147',
            rare        : 'R',
            name        : 'ワイズガールブラウンスカート',
            imgUrl      : '/images/items/AM-147.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-148',
            rare        : 'R',
            name        : 'ワイズガールブラウンシューズ',
            imgUrl      : '/images/items/AM-148.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-149',
            rare        : 'R',
            name        : 'ワイズガールブラウンヘアアクセ',
            imgUrl      : '/images/items/AM-149.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック1',
            id          : 'AM-150',
            rare        : 'R',
            name        : 'ミュージシャンレッドジャケット',
            imgUrl      : '/images/items/AM-150.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-151',
            rare        : 'R',
            name        : 'ミュージシャンレッドデニム',
            imgUrl      : '/images/items/AM-151.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-152',
            rare        : 'R',
            name        : 'ミュージシャンレッドシューズ',
            imgUrl      : '/images/items/AM-152.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-153',
            rare        : 'R',
            name        : 'ミュージシャンレッドハット',
            imgUrl      : '/images/items/AM-153.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック1',
            id          : 'AM-154',
            rare        : 'R',
            name        : 'キラキラフィーバーブルートップス',
            imgUrl      : '/images/items/AM-154.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-155',
            rare        : 'R',
            name        : 'キラキラフィーバーブルースカート',
            imgUrl      : '/images/items/AM-155.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-156',
            rare        : 'R',
            name        : 'キラキラフィーバーブルーシューズ',
            imgUrl      : '/images/items/AM-156.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-157',
            rare        : 'R',
            name        : 'キラキラフィーバーブルーヘアアクセ',
            imgUrl      : '/images/items/AM-157.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック1',
            id          : 'AM-158',
            rare        : 'R',
            name        : 'ダンシングクイーンラブリンワンピ',
            imgUrl      : '/images/items/AM-158.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-159',
            rare        : 'R',
            name        : 'ダンシングクイーンラブリンシューズ',
            imgUrl      : '/images/items/AM-159.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-160',
            rare        : 'R',
            name        : 'ダンシングクイーンラブリンヘアアクセ',
            imgUrl      : '/images/items/AM-160.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            rare        : 'R',
          }),


          item({
            collection  : 'プリチケパック1',
            id          : 'AM-161',
            rare        : 'R',
            name        : 'ローズ＆レースグリーンワンピ',
            imgUrl      : '/images/items/AM-161.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-162',
            rare        : 'R',
            name        : 'ローズ＆レースグリーンシューズ',
            imgUrl      : '/images/items/AM-162.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-163',
            rare        : 'R',
            name        : 'ローズ＆レースグリーンヘアアクセ',
            imgUrl      : '/images/items/AM-163.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'プリチケパック1',
            id          : 'AM-164',
            rare        : 'N',
            name        : 'ハッピークッキーレッドトップス',
            imgUrl      : '/images/items/AM-164.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-165',
            rare        : 'N',
            name        : 'ハッピークッキーレッドスカート',
            imgUrl      : '/images/items/AM-165.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-166',
            rare        : 'N',
            name        : 'ハッピークッキーレッドシューズ',
            imgUrl      : '/images/items/AM-166.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-167',
            rare        : 'N',
            name        : 'ハッピークッキーレッドヘアアクセ',
            imgUrl      : '/images/items/AM-167.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック1',
            id          : 'AM-168',
            rare        : 'N',
            name        : 'セーラーチアピンクリボントップス',
            imgUrl      : '/images/items/AM-168.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-169',
            rare        : 'N',
            name        : 'セーラーチアピンクリボンスカート',
            imgUrl      : '/images/items/AM-169.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-170',
            rare        : 'N',
            name        : 'セーラーチアピンクリボンシューズ',
            imgUrl      : '/images/items/AM-170.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-171',
            rare        : 'N',
            name        : 'セーラーチアピンクリボンヘアアクセ',
            imgUrl      : '/images/items/AM-171.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック1',
            id          : 'AM-172',
            rare        : 'N',
            name        : 'ル・セリアナゴージャスグリーンジャケット',
            imgUrl      : '/images/items/AM-172.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-173',
            rare        : 'N',
            name        : 'ル・セリアナゴージャススカート',
            imgUrl      : '/images/items/AM-173.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            id          : 'AM-174',
            rare        : 'N',
            name        : 'ル・セリアナローファー',
            imgUrl      : '/images/items/AM-174.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック1',
            rare        : 'N',
          }),
        ],
      }
    },

    computed: {
      itemsKR () {
        return _.where(this.items, {  rare: 'KR' })
      },

      itemsPR () {
        return _.where(this.items, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.items, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.items, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.items, {  rare: 'N' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">
    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>
    <template #col1>
      <ItemList title="KR ★★★★" color="#ff5d91" :items="itemsKR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>
    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>
    <template #col3>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>
    <template #col4>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <Status :date="date" :items="items" :showKR="true" />
    </template>
    <template #col5>
    </template>
    <template #col6>
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // (position: absolute になっている) PC 画面のみ
  .Page ::v-deep .Status {
    bottom: 0;
  }

  // 現在の所持枚数が 0 で、かつ手放した枚数が 1 以上のとき
  .Page ::v-deep .Item__status .ItemBadge.-released:first-child {
    margin-top: 2.5em;
  }
</style>
